import React from "react"
import { Link } from "gatsby"

const InternalLink = props => {
  // console.log("internal link!!!", props)
  return (
    <a
      className="external-link"
      href={`${props.href}/`}
      title={props.title || props.children}
    >
      {props.children}
    </a>
  )
}

export default InternalLink
